module.exports = __webpack_public_path__ + "img/collatz-details2.7dc91436.png";